const prefixer = string => `SUMMARY-${string}`;

export const MARITAL_STATUS = prefixer('MARITAL_STATUS');
export const PARTNER_NAME = prefixer('PARTNER_NAME');
export const AGE = prefixer('AGE');
export const AGES = prefixer('AGES');
export const CHILDREN = prefixer('CHILDREN');
export const CHILDREN_DETAILS = prefixer('CHILDREN_DETAILS');
export const TAX_FILING_STATE = prefixer('TAX_FILING_STATE');
export const INCOME = prefixer('INCOME');
export const EXPENSES = prefixer('EXPENSES');
export const EARMARKED_ACCOUNTS = prefixer('EARMARKED_ACCOUNTS');
export const PENSIONS = prefixer('PENSIONS');

export const CHILDREN_DETAILS_EDUCATION = prefixer('CHILDREN_DETAILS_EDUCATION');
export const ENROLLMENT_AGE = prefixer('ENROLLMENT_AGE');
export const SPECIFIC_COLLEGE = prefixer('SPECIFIC_COLLEGE');
export const COLLEGE_NAME = prefixer('COLLEGE_NAME');
export const TUITION_TYPE = prefixer('TUITION_TYPE');
export const DURATION = prefixer('DURATION');
export const SCHOOL_TYPE = prefixer('SCHOOL_TYPE');
export const EXPECTED_TUITION = prefixer('EXPECTED_TUITION');

export const DEBTS = prefixer('DEBTS');

export const PROPERTY_NAME = prefixer('PROPERTY_NAME');
export const HOME_PURCHASE_YEAR = prefixer('HOME_PURCHASE_YEAR');
export const HOME_PURCHASE_VALUE = prefixer('HOME_PURCHASE_VALUE');
export const MORTGAGE = prefixer('MORTGAGE');
export const DOWN_PAYMENT = prefixer('DOWN_PAYMENT');
export const MORTGAGE_DETAILS = prefixer('MORTGAGE_DETAILS');
export const PROPERTY_TAX = prefixer('PROPERTY_TAX');
export const HOMEOWNER_INSURANCE = prefixer('HOMEOWNER_INSURANCE');
export const HOA = prefixer('HOA');
export const HOA_DETAILS = prefixer('HOA_DETAILS');

export const LARGE_PURCHASE_YEAR = prefixer('LARGE_PURCHASE_YEAR');
export const LARGE_PURCHASE_VALUE = prefixer('LARGE_PURCHASE_VALUE');
export const LARGE_PURCHASE_NAME = prefixer('LARGE_PURCHASE_NAME');

export const EMERGENCY_FUND_TARGET_AMOUNT = prefixer('EMERGENCY_FUND_TARGET_AMOUNT');
export const EMERGENCY_FUND_TARGET_YEAR = prefixer('EMERGENCY_FUND_TARGET_YEAR');

export const HEALTHCARE_START_AT_RETIREMENT = prefixer('HEALTHCARE_START_AT_RETIREMENT');
export const HEALTHCARE_ANNUAL_EXPENSE = prefixer('HEALTHCARE_ANNUAL_EXPENSE');

export const DECUMULATION_YEARLY_DISTRIBUTION = prefixer('DECUMULATION_YEARLY_DISTRIBUTION');
export const DECUMULATION_DISTRIBUTION_YEARS = prefixer('DECUMULATION_DISTRIBUTION_YEARS');
